import { Component, Inject, OnInit } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";

@Component({
  selector: "app-bottom-sheet-item-description",
  templateUrl: "./bottom-sheet-item-description.component.html",
  styleUrls: ["./bottom-sheet-item-description.component.scss"],
})
export class BottomSheetItemDescriptionComponent implements OnInit {
  constructor(
    private bottomSheetRef: MatBottomSheetRef<BottomSheetItemDescriptionComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) {}

  ngOnInit() {
    console.log(this.data);
  }

  close(): void {
    this.bottomSheetRef.dismiss();
  }
}
